/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  color?: string;
};

const SvgComponent: FC<IProps> = ({ width = 20, height = 20, color = "#262626" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.75 19C11.5333 19 11.3543 18.9293 11.213 18.788C11.071 18.646 11 18.4667 11 18.25V13H5.75C5.53333 13 5.35433 12.929 5.213 12.787C5.071 12.6457 5 12.4667 5 12.25C5 12.0333 5.071 11.854 5.213 11.712C5.35433 11.5707 5.53333 11.5 5.75 11.5H11V6.25C11 6.03333 11.071 5.85433 11.213 5.713C11.3543 5.571 11.5333 5.5 11.75 5.5C11.9667 5.5 12.146 5.571 12.288 5.713C12.4293 5.85433 12.5 6.03333 12.5 6.25V11.5H17.75C17.9667 11.5 18.146 11.5707 18.288 11.712C18.4293 11.854 18.5 12.0333 18.5 12.25C18.5 12.4667 18.4293 12.6457 18.288 12.787C18.146 12.929 17.9667 13 17.75 13H12.5V18.25C12.5 18.4667 12.4293 18.646 12.288 18.788C12.146 18.9293 11.9667 19 11.75 19Z" fill={color}/>
  </svg>

);

export default SvgComponent;
